export default [
  {
    path: '/boarder',
    redirect: '/boarder/main',
    component: () => import('../../components/boarder/Layout'),
    children: [
      {
        path: 'main',
        name: 'boarder.main',
        component: () => import('../../views/boarder/Main'),
        meta: {
          roles: [7]
        }
      }
    ]
  }
]
